import { getSchema as getSchema1, getValidate, uiSchema as uiSchema1, } from "./schema.addAddress.1";
// eslint-disable-next-line import/no-default-export
export default (function (defaultValues, extraData) {
    if (defaultValues === void 0) { defaultValues = {}; }
    if (extraData === void 0) { extraData = { withGoogleMapsInput: true }; }
    return [
        {
            schema: getSchema1(defaultValues),
            uiSchema: uiSchema1(extraData),
            validate: getValidate(),
        },
    ];
});
